export default {
  async paglierani_init(_vm) {
    // Carico i pricing locali
    await _vm.$store.dispatch("paglieraniContactPricing/load", _vm.$vlf("paglieraniContactPricing"));
    // Provo ad aggiornarli dal server
    try {
      const response = await _vm.$http.get("paglierani");
      await _vm.$store.dispatch("paglieraniContactPricing/update", {
        vlf: _vm.$vlf("paglieraniContactPricing"),
        objs: response.data.contactPricing,
        cleanFilters: []
      });
      console.log('data loaded');
    } catch(e) {
      console.log(e);
    }
  },
  paglierani_customSearchFunction(_vm, string) {
    const results = [];
    // Search agents
    _vm.$store.getters["paglieraniContactPricing/getAll"].filter(
        p => !!_vm.$store.getters["contacts/get"](p.contact) 
          && (p.contactQualification == "aEsclusivo" || p.contactQualification == "aPprogetto" || p.contactQualification == "sub")
      )
      .map(p => _vm.$store.getters["contacts/get"](p.contact))
      .filter(c => -1 !== _vm.$anm22.getContactName(c, _vm.$store).search(new RegExp(string, "i")) )
      .filter(
        (contact, index, arrayResult) =>
          arrayResult.findIndex(
            r => r.idContactsContact === contact.idContactsContact
          ) === index
      )
      .map(a => {
        return {
          label: _vm.$anm22.getContactName(a, _vm.$store),
          img: _vm.$anm22.icons.getWorldIcon("agent"),
          submitFn: () => {
            _vm.$anm22.eventBus.$emit("contacts-filter", {
              name: _vm.$anm22.getContactName(a, _vm.$store),
              fn: c => {
                const agentPricing = _vm.$store.getters["paglieraniContactPricing/getByReferenceAgent"](
                  a.idContactsContact
                ).find(p => c.idContactsContact == p.contact);
                const subagentPricing = _vm.$store.getters["paglieraniContactPricing/getBySubagent"](
                  a.idContactsContact
                ).find(p => c.idContactsContact == p.contact);
                if(agentPricing) {
                  return c.idContactsContact == agentPricing.contact;
                }
                if(subagentPricing) {
                  return c.idContactsContact == subagentPricing.contact;
                }
              }
            });
          }
        };
      })
      .forEach(a => results.push(a));
    return results;
  }
}